export const isDay = () => {
  const currentTime = new Date().getHours()
  return currentTime >= 4 && currentTime < 18
}
